import { IExportPlugin, PluginType } from '@/version-types';
import { ContextMenuPlugin } from './context-menu';
import contextMenuPluginState from './states/context-menu-state';
import ContextMenu from './views/context-menu';

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 3,
    name: 'context-menu',
    render() {
        return <ContextMenu />;
    },
    createInstance({ identity }) {
        return [{ key: 'ContextMenuPlugin', value: new ContextMenuPlugin(identity) }];
    },
    createState() {
        return [contextMenuPluginState];
    },
};

export default exportPlugin;
